import React, { useEffect, useState, useCallback } from "react";
import DataLoaderOverlay from "components/DataLoaderOverlay";
import { useClientsManager } from "hooks/useClientManager";
import { useUser } from "state/user/hooks";
import { Link } from "react-router-dom";
import Input from "components/Input"; // Assuming you have an Input component

const Reports = () => {
  const { fetchCoachClients, coachClients, isLoading, setSelectedClient } = useClientsManager();
  const { user } = useUser();
  const isSuperAdmin = user?.is_SuperAdmin;
  const basisRatio = isSuperAdmin ? "basis-1/5" : "basis-1/3";
  const basisPadding = isSuperAdmin ? "pl-0" : "pl-9";
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };

  const [offset, setOffset] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(10);

  const fetchReports = useCallback((searchTerm = "", offset = 0, limit = 10) => {
    fetchCoachClients(offset, searchTerm, limit);
  }, [fetchCoachClients]);

  useEffect(() => {
    setSelectedClient(undefined);
    fetchReports(searchTerm, offset, limit);
  }, [fetchReports, setSelectedClient, searchTerm, offset, limit]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when searching
		e.preventDefault();
  };

  const handleLess = (e: React.MouseEvent) => {
    if (offset - limit >= 0) {
      setOffset(offset - limit);
    }
    e.preventDefault();
  };

  const handleMore = (e: React.MouseEvent) => {
    if (coachClients && offset + limit < coachClients.count) {
      setOffset(offset + limit);
    }
    e.preventDefault();
  };

  const handleLimitChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLimit = parseInt(e.target.value, 10);
    setLimit(newLimit);
    setOffset(0); // Reset offset when changing limit
    fetchReports(searchTerm, 0, newLimit);
  };

  return (
		<div className="pt-14 bg-main">
			<div className="flex flex-col justify-center">
				<div className="px-[40px] w-full">
					<div className="overflow-x-auto w-full sm:w-9/12 mx-auto">
						<div className="flex flex-row items-center mb-4">
							<div className="basis-1/2"><h1 className="text-4xl">Reports</h1></div>
						</div>
						<Input
							type="text"
							placeholder="Search by client name"
							value={searchTerm}
							onChange={handleSearch}
							className="w-full bg-white"
						/>
						<DataLoaderOverlay isLoading={isLoading}>
							<div className="bg-[#FCFCFC] pt-8 my-8">
								<div className="flex flex-row text-xl pb-6 italic">
									{isSuperAdmin &&
										<>
										<span className="basis-1/6 pl-4">Id</span>
										<span className="basis-1/5">Coach</span>
										</>
									}
									<span className={[basisRatio, basisPadding].join(" ")}>Client Name</span>
									<span className={basisRatio}>Status</span>
									<span className={basisRatio}>Date Created</span>
								</div>
								{coachClients.results && coachClients.results.map((report, i) => (
									<Link to={"/categories/" + report.id} className="flex flex-row py-4 border-t font-helvetica" key={i}>
										{isSuperAdmin &&
											<>
											<span className="basis-1/6 pl-4">{report.id}</span>
											<span className="basis-1/5">{report.coach.first_name} {report.coach.last_name}</span>
											</>
										}
										<span className={[basisRatio, basisPadding].join(" ")}>{report.client_name}</span>
										<span className={basisRatio}>{report.status}</span>
										<span className={basisRatio}>{new Date(Date.parse(report.date_created)).toLocaleDateString('en-US', options)}</span>
									</Link>
								))}
							</div>
						</DataLoaderOverlay>
						<div className="flex flex-row">
							<div className="basis-1/2">
								<button 
									onClick={handleLess} 
									disabled={offset === 0}
									className={`py-3 px-4 rounded-md px-[30px] text-xl bg-white max-w-[200px] ${offset === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
								>
									Less
								</button>
							</div>
							<label className="py-3 px-4 text-xl">Limit:</label>  {/* Assuming you have a label component */}
							<select
								value={limit}
								onChange={handleLimitChange}
								className="py-3 px-4 rounded-md text-xl bg-white"
							>
								<option value="10">10</option>
								<option value="20">20</option>
								<option value="50">50</option>
							</select>
							<div className="basis-1/2">
								<button 
									onClick={handleMore} 
									disabled={coachClients && offset + limit >= coachClients.count}
									className={`py-3 px-4 rounded-md px-[30px] text-xl bg-white max-w-[200px] float-right ${coachClients && offset + limit >= coachClients.count ? 'opacity-50 cursor-not-allowed' : ''}`}
								>
									More
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
  );
};

export default Reports;